import React, { useEffect } from 'react';
import { Award, CheckCircle, Info, AlertCircle } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, title }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 4000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const styles = {
        achievement: { bg: 'bg-yellow-500', icon: <Award className="w-6 h-6 text-white" /> },
        success: { bg: 'bg-green-500', icon: <CheckCircle className="w-6 h-6 text-white" /> },
        error: { bg: 'bg-red-500', icon: <AlertCircle className="w-6 h-6 text-white" /> },
        info: { bg: 'bg-blue-500', icon: <Info className="w-6 h-6 text-white" /> }
    };

    const style = styles[type] || styles.info;

    return (
        <div className={`fixed top-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-xl shadow-2xl text-white transform transition-all duration-500 animate-fade-in-down ${style.bg} border-2 border-white/20`}>
            <div className="p-2 bg-white/20 rounded-full">
                {style.icon}
            </div>
            <div>
                {title && <p className="font-bold text-sm uppercase tracking-wide opacity-90 shadow-sm">{title}</p>}
                <p className="font-medium text-sm">{message}</p>
            </div>
            <button onClick={onClose} className="ml-2 opacity-70 hover:opacity-100">✕</button>
        </div>
    );
};

export default Toast;
